import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner'
import { saveAs } from 'file-saver';
import { unparse } from 'papaparse';
import { useUser } from '../../../store/userState';

import { Tooltip } from "@material-tailwind/react";
import { ArchiveBoxXMarkIcon, ArrowDownTrayIcon, DocumentCheckIcon, DocumentMinusIcon, InformationCircleIcon, PencilSquareIcon, TrashIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { PopViewThread } from "./PopViewThread";
import DropdownSelect from '../../../Components/DropdownSelect';
import DataTableShell from '../../../Components/table/DataTableShell';
import TableToolbar from '../../../Components/table/TableToolbar';
import TableSearch from '../../../Components/table/TableSearch';
import {
    TableActionGroup,
    TableEmptyRow,
    TableIdCell,
    TableSkeletonRows,
    TableStatusChip,
} from '../../../Components/table/TableCells';
import useClientTable from '../../../Components/table/useClientTable';

const TABLE_HEAD = ["Creation Date", "Updated Date", "Case ID", "Status","Primary Email", "Short Description", "SAS Sent", "Actions"];

export default function AmzCasesTable({ isAltereds }) {
    const [cases, setCases] = useState([])
    const [isLoad, setIsLoad] = useState(false)
    const [isAltered, setIsAltered] = useState(false)
    const [countdown, setCountdown] = useState(60)
    const [caseList, setCaseList] = useState([])
    const [isMultipleUpdate, setIsMultipleUpdate] = useState(false)
    const [delMulCase, setDelMulCase] = useState([])
    const [checkedCases, setCheckedCases] = useState({});
    const [selectedValue, setSelectedValue] = useState('');

    const { user } = useUser();
    const userEmail = user.email;
    
    const casesPerPage = 10;
    const filterCase = useCallback((item, query) => {
        const matchesOwner =
            selectedValue !== 'myCases' ||
            item.addedBy?.toLowerCase() === userEmail.toLowerCase();
        const matchesSearch =
            !query ||
            item.caseId?.toString().toLowerCase().includes(query) ||
            item.descriptions?.toLowerCase().includes(query) ||
            item.email?.toLowerCase().includes(query) ||
            item.addedBy?.toLowerCase().includes(query);

        return matchesOwner && matchesSearch;
    }, [selectedValue, userEmail]);

    const sortCases = useCallback((a, b) => {
        const isAEmpty = !a.latestDate || !a.dateCreated || !a.status;
        const isBEmpty = !b.latestDate || !b.dateCreated || !b.status;
    
        if (isAEmpty && !isBEmpty) {
            return -1;
        } else if (!isAEmpty && isBEmpty) {
            return 1;
        }
    
        if (selectedValue === 'recentlyUpdated') {
            return new Date(b.latestDate) - new Date(a.latestDate);
        }
        return 0;
    }, [selectedValue]);

    const {
        searchTerm,
        handleSearch,
        currentPage,
        setCurrentPage,
        pageItems: currentCases,
        totalPages,
        totalFiltered,
    } = useClientTable({
        data: cases,
        pageSize: casesPerPage,
        filterFn: filterCase,
        sortFn: sortCases,
    });

    useEffect(() => {
        const toggleInterval = setInterval(() => {
            setIsAltered(prevState => !prevState);
            setCountdown(60); 
        }, 60000); 

        const countdownInterval = setInterval(() => {
            setCountdown(prevCountdown => prevCountdown - 1);
        }, 1000); 

        return () => {
            clearInterval(toggleInterval);
            clearInterval(countdownInterval);
        };
    }, []);

    useEffect(() => {
        setIsLoad(true);

        axios.get('/api/amz-cases/get')
            .then(response => {
                if (response.data.message) {
                    console.log("Cannot get cases");
                } else {
                    setCaseList(response.data.result);
                    let caseIds = [];
                    response.data.result.map(item => caseIds.push(item.caseId));
                    axios.post('https://api-central.outdoorequippedservice.com/api/v1/amazon-cases/summary/multiple', { caseIds })
                        .then(res => setCases(res.data));
                };
                setIsLoad(false);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }, [isAltered, isAltereds]);

    const handleUpdateCase = (caseId, sasSent) => {
        console.log('sas', caseId, sasSent)

        const updateCase = {
            sasSent: !sasSent
        }

        axios.put(`/api/amz-cases/update/${caseId}`, updateCase)
        .then(response => {
            if (response.data.message) {
                toast.success(`${response.data.message}`);
                setIsAltered(prevState => !prevState);
            } else {
                toast.error(`${response.data.message}`);
                console.log('Error:', response.data.error);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });

    }

    const handleDeleteCase = (caseId) => {
        const isConfirmed = window.confirm(`Are you sure you want to delete this case ${caseId}?`);

        if (isConfirmed) {
            axios.delete(`/api/amz-cases/delete/${caseId}`)
                .then(response => {
                    if (response.data.message) {
                        toast.success(`${response.data.message}`);
                        setIsAltered(prevState => !prevState);
                    } else {
                        toast.error(`${response.data.message}`);
                        console.log('Error:', response.data.error);
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        }
    };

    const toggleMultipleDelete = () => {setIsMultipleUpdate(!isMultipleUpdate)}

    const cancelMultipleDelete = () => {
        setIsMultipleUpdate(!isMultipleUpdate) 
        setDelMulCase([])
        setCheckedCases({})
    }

    const storeMultipleCaseToDel = (caseId, isChecked) => {
        setDelMulCase((prevCases) => {
            if (isChecked) {
                return [...prevCases, caseId];
            } else {
                // Remove caseId from the array
                return prevCases.filter((id) => id !== caseId);
            }
        });
        setCheckedCases((prevCheckedCases) => ({
            ...prevCheckedCases,
            [caseId]: isChecked,
        }));
    }
    useEffect(() => {
        console.log('multiple case:', delMulCase);
    }, [delMulCase]);

    const handleDeleteCases = () => {
        const isConfirmed = window.confirm(`Are you sure you want to delete these cases?`);

        const deleteMultipleCases = {
            ids: delMulCase
        }
        console.log(deleteMultipleCases)

        if (isConfirmed) {
            axios.post(`/api/amz-cases/delete`, deleteMultipleCases)
                .then(response => {
                    if (response.data.message) {
                        toast.success(`${response.data.message}`);
                        setIsMultipleUpdate(!isMultipleUpdate)
                        setIsAltered(prevState => !prevState);
                        console.log('Deleted cases:', delMulCase)
                    } else {
                        toast.error(`${response.data.message}`);
                        console.log('Error:', response.data.error);
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        }
    }

    const exportToCsv = () => {
        const headers = ["Creation Date", "Updated Date", "Case ID", "Status", "Primary Email", "Short Description"];
        
        const filteredCases = cases.filter(({ status, latestDate, caseId }) => {

            const sasSent = caseList.find((item) => item.caseId === caseId).sasSent

            if (sasSent === true) return false
            if (status !== 'Resolved') return false;
            const updatedDate = new Date(latestDate);
            if (isNaN(updatedDate.getTime())) return false;
            const currentDate = new Date();
            const timeDifference = currentDate.getTime() - updatedDate.getTime();
            const daysDifference = timeDifference / (1000 * 3600 * 24);
            return daysDifference >= 5;
        });
        
        const data = filteredCases.map(({ dateCreated, latestDate, caseId, status, email, descriptions }) => ({
            "Creation Date": dateCreated,
            "Updated Date": latestDate,
            "Case ID": caseId,
            "Status": status,
            "Primary Email": email,
            "Short Description": descriptions
        }));
        
        const csv = unparse({ fields: headers, data });
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'resolved_cases_5_days_old_or_beyond.csv');
    };

    const handleSelectChange = (value) => {
        setSelectedValue(value);
        setCurrentPage(1);
    };

    return (
        <DataTableShell
            minWidth="1160px"
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            toolbar={
                <TableToolbar
                    kicker="Listings"
                    title="Amazon cases"
                    subtitle={`${totalFiltered} matching · ${cases.length} monitored · refresh in ${countdown}s`}
                    actions={
                        <TableActionGroup>
                            <Tooltip content="Export resolved cases (5 days or over)">
                                <button type="button" className="nx-btn-ghost gap-2" onClick={exportToCsv}>
                                    Export file
                                    <ArrowDownTrayIcon className="h-5 w-5" />
                                </button>
                            </Tooltip>
                            {!isMultipleUpdate ? (
                                <Tooltip content="Delete multiple">
                                    <button type="button" className="nx-btn-ghost p-2 text-signal" onClick={toggleMultipleDelete}>
                                        <PencilSquareIcon className="h-5 w-5" />
                                        <span className="sr-only">Select cases to delete</span>
                                    </button>
                                </Tooltip>
                            ) : (
                                <>

                                    <Tooltip content="Delete selected cases">
                                        <button type="button" className="nx-btn-ghost p-2 text-success" onClick={handleDeleteCases}>
                                            <ArchiveBoxXMarkIcon className="h-5 w-5" />
                                            <span className="sr-only">Delete selected cases</span>
                                        </button>
                                    </Tooltip>
                                    <Tooltip content="Cancel">
                                        <button type="button" className="nx-btn-ghost p-2 text-danger" onClick={cancelMultipleDelete}>
                                            <XMarkIcon className="h-5 w-5" />
                                            <span className="sr-only">Cancel multiple delete</span>
                                        </button>
                                    </Tooltip>
                                </>
                            )}
                        </TableActionGroup>
                    }
                >
                    <DropdownSelect onSelectChange={handleSelectChange} />
                    <TableSearch
                        id="amazon-cases-search"
                        value={searchTerm}
                        onChange={handleSearch}
                        placeholder="Search cases"
                    />
                </TableToolbar>
            }
        >
            <thead>
                <tr>
                    {TABLE_HEAD.map((head) => <th key={head}>{head}</th>)}
                </tr>
            </thead>
            <tbody>
                {isLoad ? (
                    <TableSkeletonRows columns={TABLE_HEAD.length} rows={casesPerPage} />
                ) : currentCases.length === 0 ? (
                    <TableEmptyRow
                        columns={TABLE_HEAD.length}
                        title="No cases found"
                        description="Try a different search or case filter."
                    />
                ) : currentCases.map(({ caseId, status, email, latestDate, dateCreated, descriptions, addedBy }) => {
                    const sasSent = caseList.find((item) => item.caseId === caseId)?.sasSent ?? false;
                    const renderDate = (value) => value ? (
                        <span className="flex flex-col font-mono text-xs">
                            <span>{value.split(',')[0]}</span>
                            <span className="text-muted">{value.split(',')[1]}</span>
                        </span>
                    ) : <span className="text-muted">Pending</span>;

                    return (
                        <tr key={caseId}>
                            <td>{renderDate(dateCreated)}</td>
                            <td>{renderDate(latestDate)}</td>
                            <td>
                                <div className="flex items-center gap-1">
                                    <TableIdCell>{caseId}</TableIdCell>
                                    {addedBy && (
                                        <Tooltip content={`Added by: ${addedBy}`}>
                                            <InformationCircleIcon className="h-4 w-4 text-muted" />
                                        </Tooltip>
                                    )}
                                </div>
                            </td>
                            <td>
                                {status ? <TableStatusChip status={status} /> : <span className="text-muted">Pending</span>}
                            </td>
                            <td className="text-muted">{email || 'Pending'}</td>
                            <td title={descriptions}>
                                {descriptions
                                    ? descriptions.length > 45
                                        ? `${descriptions.substring(0, 45)}...`
                                        : descriptions
                                    : <span className="text-muted">Pending</span>}
                            </td>
                            <td>
                                <TableStatusChip status={sasSent ? 'Sent' : 'Not sent'} tone={sasSent ? 'ok' : 'bad'} />
                            </td>
                            <td>
                                <TableActionGroup>
                                    <PopViewThread caseId={caseId} shortDesc={descriptions} />
                                    <Tooltip content="Toggle SAS sent status">
                                        <button
                                            type="button"
                                            className={`nx-btn-ghost p-2 ${sasSent ? 'text-warning' : 'text-success'}`}
                                            onClick={() => handleUpdateCase(caseId, sasSent)}
                                        >
                                            {sasSent ? <DocumentMinusIcon className="h-5 w-5" /> : <DocumentCheckIcon className="h-5 w-5" />}
                                            <span className="sr-only">Toggle SAS sent status</span>
                                        </button>
                                    </Tooltip>
                                    {isMultipleUpdate ? (
                                        <label className="flex cursor-pointer items-center p-2">
                                            <input
                                                type="checkbox"
                                                className="h-4 w-4 accent-amber-500"
                                                checked={!!checkedCases[caseId]}
                                                onChange={(event) => storeMultipleCaseToDel(caseId, event.target.checked)}
                                            />
                                            <span className="sr-only">Select case {caseId}</span>
                                        </label>
                                    ) : (
                                        <Tooltip content="Remove case">
                                            <button
                                                type="button"
                                                className="nx-btn-ghost p-2 text-danger"
                                                onClick={() => handleDeleteCase(caseId)}
                                            >
                                                <TrashIcon className="h-5 w-5" />
                                                <span className="sr-only">Remove case</span>
                                            </button>
                                        </Tooltip>
                                    )}
                                </TableActionGroup>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </DataTableShell>
    );
}